import { render, staticRenderFns } from "./SelfServiceInner.vue?vue&type=template&id=35bba706&"
import script from "./SelfServiceInner.vue?vue&type=script&lang=js&"
export * from "./SelfServiceInner.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceInner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports